/* eslint-disable react/jsx-props-no-spreading */
import Button, { ButtonProps } from "../Button";

export enum ButtonGroupDirection {
  vertical = "vertical",
  horizontal = "horizontal",
}

export interface ButtonGroupProps {
  buttons: ButtonProps[];
  direction?: ButtonGroupDirection;
}

const ButtonGroup = ({
  buttons, direction = ButtonGroupDirection.horizontal,
}: ButtonGroupProps) => (
  <div className={`flex gap-2 ${direction === "horizontal" ? "flex-row" : "flex-col"}`}>
    {buttons.map((button, index) => (
      <Button key={index} {...button} />
    ))}
  </div>
);

export default ButtonGroup;
